import { useState, useEffect } from "react";
import { getUserId, getUserRole } from "../utils/authStorage";
import apiClient from "@shared/config/axiosConfig";

const usePendientesNotificacion = () => {
  const [pendientesSinCompletar, setPendientesSinCompletar] = useState(0);
  const [mostrarNotificacion, setMostrarNotificacion] = useState(false);
  const [yaRevisado, setYaRevisado] = useState(false);

  const getUserIdFromToken = () => {
    return getUserId();
  };

  const getRoleFromToken = () => {
    const role = getUserRole();
    if (role === null) return null;

    // Comprobar si el usuario es desarrollador (rol 5)
    if (role === 5) {
      const developerRole = sessionStorage.getItem("RolDevelop");
      if (developerRole) {
        return Number(developerRole);
      }
    }

    return role;
  };

  const verificarPendientes = async () => {
    const role = getRoleFromToken();
    // Solo verificar pendientes para usuarios con rol de inspector (2)
    if (role !== 2) return;

    const userId = getUserIdFromToken();
    if (!userId) return;

    // Comprobar si ya se ha revisado la notificación en esta sesión
    const notificacionRevisada = sessionStorage.getItem(
      "pendientesNotificacionRevisada",
    );
    if (notificacionRevisada === "true") {
      setYaRevisado(true);
      return;
    }

    try {
      const response = await apiClient.get("/pendientes", {
        params: { completado: false },
      });

      if (response.data) {
        const pendientesUsuario = Array.isArray(response.data)
          ? response.data.filter(
              (p) => String(p.idusuario_asignado) === String(userId),
            )
          : [];

        setPendientesSinCompletar(pendientesUsuario.length);

        if (pendientesUsuario.length > 0) {
          setMostrarNotificacion(true);
        }
      }
    } catch (error) {
      console.error("Error verificando pendientes:", error);
    }
  };

  const cerrarNotificacion = () => {
    setMostrarNotificacion(false);
    // Marcar como revisado en esta sesión
    sessionStorage.setItem("pendientesNotificacionRevisada", "true");
    setYaRevisado(true);
  };

  return {
    pendientesSinCompletar,
    mostrarNotificacion,
    yaRevisado,
    verificarPendientes,
    cerrarNotificacion,
  };
};

export default usePendientesNotificacion;
